import React from 'react';
import {withRouter} from 'react-router';
import {routeUrl} from './routeUrl';

@withRouter
export default class Homepage extends React.Component {
  handleNavigation() {
    this.props.router.push(routeUrl.dashboard);
  }

  render() {
    return (
        <div>
          {
            this.handleNavigation()
          }
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Homepage.js